import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { InsurerMark, INSURER_BRANDS } from "@/data/insurerBrands.jsx";

function LogoCard({ insurer }) {
  const b = INSURER_BRANDS[insurer.slug];
  const name = b?.name || insurer.name;
  return (
    <Link
      to={`/insurer/${insurer.slug}`}
      className="shrink-0 px-5 py-3.5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover-lift flex items-center gap-3 min-w-[210px] hover:border-[#003DA5]"
      data-testid={`insurer-${insurer.slug}`}
    >
      <InsurerMark slug={insurer.slug} size={42} />
      <div className="leading-tight">
        <div className="font-heading font-bold text-slate-900 dark:text-white text-sm whitespace-nowrap">{name}</div>
        <div className="text-[10px] font-semibold text-slate-500 dark:text-slate-400 whitespace-nowrap uppercase tracking-wider">Insurance Partner</div>
      </div>
    </Link>
  );
}

export default function InsurerLogoWall() {
  const [insurers, setInsurers] = useState([]);

  useEffect(() => {
    api.get("/insurers").then((r) => setInsurers(r.data)).catch(() => setInsurers([]));
  }, []);

  const loop = [...insurers, ...insurers];

  return (
    <section className="py-16 bg-white dark:bg-slate-950 border-y border-slate-100 dark:border-slate-800" data-testid="insurer-wall">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#003DA5] dark:text-blue-400 mb-2">Supporting policyholders insured with</p>
        <h2 className="font-heading text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">
          {insurers.length}+ leading insurers across India
        </h2>
      </div>
      <div className="relative overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white dark:from-slate-950 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white dark:from-slate-950 to-transparent z-10" />
        <div className="flex gap-3 animate-marquee">
          {loop.map((ins, i) => <LogoCard key={`${ins.slug}-${i}`} insurer={ins} />)}
        </div>
      </div>
    </section>
  );
}
